/* =================== ENVIA LEAD =================== */
jQuery(document).ready(function ($) {
  var enviando_formulario = false;
  $("#form-lead").on("submit", function (e) {
    $(".desconto-luz").html("");
    $(".desconto-luz-geral").html("");
    e.preventDefault();

    var obj = this;
    var form = $(obj);
    var submit_btn = form.find("#enviar");
    var submit_btn_text = submit_btn.text();
    var dados = new FormData(obj);

    function volta_submit() {
      submit_btn.attr("disabled", false);
      submit_btn.text(submit_btn_text);
      enviando_formulario = false;
      hideLoading();
    }

    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          showLoading();
          enviando_formulario = true;
          submit_btn.attr("disabled", true);
          submit_btn.text("Enviando...");
        },
        success: function (data) {
          console.log(data);
          data = JSON.parse(data);
          volta_submit();
          if (data.status == "ok") {
            $("#form-lead .campo").val("");
            const retornoUrl = form.find('input[name="retorno"]').val();
            location.href = retornoUrl;
            $(".desconto-luz").html("R$ " + formataMoeda(data.desconto));
            $(".desconto-luz-geral").html(
              "R$ " + formataMoeda(data.descontoGeral)
            );
            // openModal('modal-desconto');
            // gtagPopUp();
          } else {
            showAlert("Erro", "Não foi possível calcular o desconto.", "error");
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert("Erro", "Não foi possível calcular o desconto.", "error");
          console.log("ajax error response type " + type);
        },
      });
    }
  });
});
